module.exports = __webpack_public_path__ + "img/whataspp-desktop.d08b1ebf.svg";